import React, { useState, useEffect, useRef } from "react";
import { Modal } from "react-bootstrap";
import { HighlightOffRounded } from "@material-ui/icons";
import { useTranslation } from "react-i18next";
import { Container } from "react-bootstrap";
import request from "../../../../services/Request";
import { clearPromo, submitPromo } from "../../../../services/promo";

export default function PromoModal(props) {
  const [input, setInput] = useState("");
  const [error, setError] = useState("");

  const [showKeyboard, setShowKeyboard] = useState(false);

  const { t } = useTranslation();
  const keyboard = useRef();
  const { show, onHide, products, setShow, total } = props;

  const onChangeInput = (event) => {
    const input = event.target.value;
    setInput(input);
    keyboard.current.setInput(input);
  };
  // const handleClose = () => {
  //   setShowKeyboard(false);
  // };
  // const handleShow = () => {
  //   setShowKeyboard(true);
  // };

  useEffect(() => {
    setTimeout(() => {
      setShowKeyboard(show);
    }, 400);
    setInput("");
    setError("");
  }, [show]);

  const clearPromotion = () => {
    setError("");
    clearPromo(props.cart, props.changePrice, products);
  };

  const onPromoSubmit = async (e) => {
    clearPromotion();

    const promoData = JSON.parse(localStorage.getItem("promo"));
    let promoCode = "";
    let isFound = false;
    if (promoData) {
      isFound = await submitPromo(
        promoData,
        input,
        props.cart,
        props.changePrice,
        request
      );

      console.log("isFound", isFound);
      if (!isFound) {
        // logger(1, 'A invalid promote code has been entered');
        setError(t("The code is not valid"));
      } else {
        setShow(false);
      }
    }
  };

  return (
    <Modal show={show} onHide={onHide} size="md" centered>
      <Modal.Body className="ui-bg-color promo-modal">
        <HighlightOffRounded
          className="close_circle_icon"
          style={{ fontSize: "40px", marginTop: "0px" }}
          onClick={() => {
            props.onHide();
          }}
        />
        <div
          id="close_promo_modal"
          onClick={() => {
            props.onHide();
          }}
        ></div>
        <Container>
          <div className="d-flex flex-column align-items-center justify-content-center mt-4 pb-4">
            <div className="promo-text mb-5">
              {t(`Scan or enter your promotion code`)}
            </div>
            <input
              type="search"
              placeholder={t(`Discount Code`)}
              value={input}
              // onClick={handleShow}
              onChange={onChangeInput}
              aria-label="Search"
              className="promo-input"
            />
            {/* {showKeyboard && (
              <KeyBoard
                show={showKeyboard}
                setShow={setShowKeyboard}
                handleClick={onPromoSubmit}
                send={true}
                // handleClose={onHide()}
                input={input}
                setInput={setInput}
                keyboard={keyboard}
              />
            )} */}
            {error && <div className="cart-checkout-error mt-5">{error}</div>}
          </div>
        </Container>
      </Modal.Body>
    </Modal>
  );
}
